<template>
  <footer class="footer-block">
    <container>
      <div class="footer-block__inner">
        <section class="footer-block__section">
          <img class="footer-block__logo" src="../assets/icons/magor.svg" alt />
          <h6 class="footer-block__name">Design e Comunicação Criativa</h6>
          <p
            class="footer-block__text"
          >Entendemos cada negócio, cada meta e desafio que passam pela agência, e usamos ferramentas inteligentes para traçar uma estratégia de comunicação que realmente funcione para sua marca.</p>
        </section>
        <section class="footer-block__section">
          <h6 class="footer-block__title">
            <img src="../assets/icons/address.svg" alt />
            Endereço
          </h6>
          <p class="footer-block__text">
            Rua Bom Pastor, 2100 - 8º andar
            <br />Ipiranga - SP
            <br />CEP 04203-002
            <br />
          </p>
          <p class="footer-block__map-mob">
            <a
              class="footer-block__button"
              target="_blank"
              href="https://goo.gl/maps/grDU8SDrTh3DtjcVA"
            >Abrir Maps</a>
            &nbsp;
            <a
              class="footer-block__button"
              target="_blank"
              href="https://www.waze.com/pt-BR/live-map/directions/br/sp/r.-bom-pastor,-2100?to=place.ChIJBVweyuxbzpQRi6ULTcACgrE"
            >Abrir Waze</a>
          </p>
          <p class="footer-block__map-desk">
            <a
              class="footer-block__button"
              target="_blank"
              href="https://goo.gl/maps/grDU8SDrTh3DtjcVA"
            >Ver no mapa</a>
          </p>
        </section>
        <section class="footer-block__section footer-block__section--small">
          <h6 class="footer-block__title">
            <img src="../assets/icons/email.svg" alt />
            Email
          </h6>
          <p class="footer-block__text">
            <a class="footer-block__mail" href="mailto:contato@magor.com.br">contato@magor.com.br</a>
          </p>
        </section>
        <!-- <section class="footer-block__section footer-block__section--small">
          <h6 class="footer-block__title">
            <img src="../assets/icons/phone.svg" alt />
            <span>
              Ligue
              <i>(9h –18h30)</i>
            </span>
          </h6>
          <p class="footer-block__text">
            +55 11
            <b>3624 6424</b>
          </p>
        </section> -->
        <section class="footer-block__section footer-block__section--small">
          <h6 class="footer-block__title">
            <img src="../assets/icons/email.svg" alt />
            Redes sociais
          </h6>
          <div class="footer-block__social">
            <a href="https://www.facebook.com/magorcomunicacao" target="_blank">
              <img src="../assets/icons/footer-facebook.svg" alt />
            </a>
            <a href="https://www.linkedin.com/company/magor-est-dio-de-cria-o" target="_blank">
              <img src="../assets/icons/footer-linkedin.svg" alt />
            </a>
            <a href="https://www.instagram.com/_magor/" target="_blank">
              <img src="../assets/icons/footer-instagram.svg" alt />
            </a>
          </div>
        </section>
        <section class="footer-block__section footer-block__section--small">
          <p class="footer-block__text">
            <!-- All rights reserved<br class="footer-block__wbr"> -->
            &copy; Magor {{ dataAtual }}
          </p>
        </section>
      </div>
    </container>
  </footer>
</template>

<script>
import Container from "@/components/Container";

export default {
  components: {
    Container
  },
  computed: {
    dataAtual() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars.scss";

.footer-block {
  padding: 5.6rem 0 3.4rem;

  color: #505050;
  background-color: #f5f5f5;

  @media (min-width: $min-md) {
    padding: 8.5rem 0 9rem;
  }

  &__inner {
    display: grid;

    gap: 2.6rem;

    @media (max-width: $max-sm) and (min-width: $min-sm) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: $min-md) {
      grid-template-rows: auto 1fr;
      grid-template-columns: 4fr 3fr 3fr 3fr;

      grid-auto-flow: column;
    }
  }

  &__section {
    &:first-child {
      @media (max-width: $max-sm) and (min-width: $min-sm) {
        grid-column: 1 / -1;
      }
    }
    @media (min-width: $min-md) {
      grid-row: 1 / -1;
    }

    &--small {
      @media (min-width: $min-md) {
        grid-row: unset;
      }
    }
  }

  &__logo {
    width: 8.4rem;

    @media (min-width: $min-md) {
      width: 15rem;
    }
  }

  &__name {
    font-size: 1.8rem;
    line-height: 1.2;

    margin: 1rem 0;

    @media (min-width: $min-md) {
      font-size: 2rem;
    }
  }

  &__text {
    font-size: 1.5rem;
    font-weight: 300;
    line-height: 1.6;

    margin-bottom: 1rem;

    b {
      font-size: 2.1rem;
      font-weight: 700;
      line-height: 1.15;
    }
  }

  &__mail {
    text-decoration: none;

    color: inherit;
  }

  &__title {
    font-size: 1.4rem;
    line-height: 1.2;

    display: grid;
    align-items: center;
    justify-content: start;

    margin-bottom: 1rem;

    color: #000;

    grid-template-columns: repeat(2, auto);

    gap: 1rem;

    i {
      font-style: italic;
    }
  }

  &__social {
    display: inline-grid;
    align-items: center;

    grid-template-columns: repeat(4, auto);

    gap: 1.5rem;
  }

  &__input {
    position: relative;

    display: block;

    input {
      font-size: 1.5rem;
      font-weight: 300;
      line-height: 1.6;

      display: block;

      width: 100%;
      padding: 0;

      color: inherit;
      border: 0;
      border-bottom: 1px solid #979797;
      background-color: transparent;

      &::placeholder {
        font-style: italic;
      }
    }

    button {
      position: absolute;
      top: 0;
      right: 0;

      display: flex;
      align-items: center;
      justify-content: center;

      width: 2.2rem;
      height: 2.2rem;
      padding: 0;

      border: 0;
      border-radius: 50%;
      background-color: #d8d8d8;
    }

    img {
      width: 1.6rem;
    }
  }

  &__button {
    font-size: 1.3rem;
    line-height: 1.3;

    display: inline-block;

    padding: 0 1.5rem;

    text-decoration: none;

    color: #f5f5f5;
    border-radius: 0.8rem;
    background-color: #979797;

    @media (min-width: $min-md) {
      font-size: 1.4rem;
    }
  }

  &__map-mob {
    @media (min-width: $min-md) {
      display: none;
    }
  }

  &__map-desk {
    display: none;

    @media (min-width: $min-md) {
      display: unset;
    }
  }

  &__wbr {
    display: none;

    @media (min-width: $min-md) {
      display: unset;
    }
  }
}
</style>
